

import { useTheme } from './ThemeProvider'
import { Sun, Moon } from 'lucide-react'

export default function ThemeToggle() {
  const { theme, setTheme } = useTheme()

  const toggleTheme = () => {
    setTheme(theme === 'light' ? 'dark' : 'light')
  }

  const getIcon = () => {
    return theme === 'light' ? <Sun className="h-5 w-5" /> : <Moon className="h-5 w-5" />
  }

  const getLabel = () => {
    return theme === 'light' ? 'Light' : 'Dark'
  }

  return (
    <button
      onClick={toggleTheme}
      className="inline-flex items-center justify-center w-9 h-9 text-gray-700 dark:text-zinc-300 hover:bg-gray-100 dark:hover:bg-[var(--bg-2)] rounded-md focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[var(--focus-ring)] dark:focus:ring-offset-[var(--bg-0)] transition-colors"
      aria-label={`Current theme: ${getLabel()}. Click to toggle theme.`}
      title={`Current theme: ${getLabel()}`}
    >
      {getIcon()}
    </button>
  )
}
